import useTranslator from "@hooks/use-translator";
import { Input } from "@components/common/input";
import { Button } from "@components/common/button";
import { PlusCircle } from "lucide-react";
import axios from "axios";
import { ADD_JOB_TITLE_ENDPOINT, SERVER_URL } from "@pma/utils/api-routes";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "@stores/auth-store";
import { parseCookies } from "nookies";
import { ACCESS_TOKEN } from "@pma/utils/constants";
import { useState } from "react";
import { DictType } from "@pma/types";
import { toast } from "@hooks/use-toast";

const AddJobTitle = () => {
  const [jobTitle, setJobTitle] = useState("");
  const { translate, locale } = useTranslator();
  const { authConfig } = useAuth();

  const accessToken = parseCookies()[ACCESS_TOKEN];

  const orgId = authConfig?.last_organization_id;

  const addJobTitle = async () => {
    const response = await axios.post(
      SERVER_URL + ADD_JOB_TITLE_ENDPOINT,
      {
        job_title: jobTitle,
        organization_id: orgId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.data;
  };

  const addJobTitleMutation = useMutation({
    mutationKey: ["add-job-title"],
    mutationFn: addJobTitle,
    onSuccess: (data) => {
      setJobTitle("");
    },
    onError: (error: DictType) => {
      toast({
        title: translate("Error"),
        description: error?.response?.data.message ||
                translate(`Error occurred while updating`) +
                  " " +
                  translate(`job title`),
        variant: "error",
      });
    },
  });

  const onSubmit = (e: any) => {
    e.preventDefault();
    addJobTitleMutation.mutate();
  };

  return (
    <form onSubmit={onSubmit} className="flex items-center gap-2">
      <Input
        placeholder={translate("Add Job title")}
        className="rounded-full"
        required
        onChange={(e) => setJobTitle(e.target.value)}
      />
      <Button size={"sm"} className="rounded-full h-7 w-7 m-0 p-0">
        <PlusCircle className=" h-7 w-7 rounded-full" />
      </Button>
    </form>
  );
};

export default AddJobTitle;
